import { useState, useEffect, useRef, Fragment, memo, useMemo, useContext } from "react";
import style from "./../index.module.scss";
import styleUi from "./SendInvite.module.scss";
import { v4 } from "uuid";

import { CSSTransition } from 'react-transition-group';
import AppConfig from '../../AppConfig';
import TabList from "../../comm/global/components/TabList";
import * as YStyled from '../../Styleds';
import 'swiper/css/effect-flip';
import apiManager from '../../ApiManager';
import html2canvas from 'html2canvas';
import { GameContext } from "../../GameContext";
import { addTextToImage } from "../../comm/comm";
import SwifeItem from "../../comm/global/components/SwifeItem";
import DivInput from "../../comm/global/components/DivInput";
import styled from "styled-components";

const SendInvite = ({ setModalType, arg, addModalType }) => {
    const [inProp, setInProp] = useState(false);
    const [state, set_state] = useState(0);
    const [selTempInd, set_selTempInd] = useState(0);
    const [tempSrc, set_tempSrc] = useState("");
    const selMode = useRef("");
    const { friends } = useContext(GameContext);
    const [participants, set_participants] = useState([]);

    const [msg, set_msg] = useState("");

    useEffect(() => {
        const findObj = AppConfig.modeEnum.find(v => v.id === arg.vo.events_type);
        console.log("SendInvite", arg, findObj);
        selMode.current = findObj;
        set_msg(`Hi~\n我想邀請你加入\n我在 OOSA 上舉辦的\n${arg.vo.events_name}\n一起去${selMode.current.label}吧！`)
        //typeImg
        apiManager.fetchGet(`event/${arg.vo.events_id}/participants`, {}, 0).then(res => {
            set_participants(res);
        })
        setInProp(true);
    }, [])

    useEffect(() => {
        const posDetail = AppConfig.InvitePosDetail(selTempInd, arg.vo, selMode.current);
        addTextToImage(`./assets/ui/invite${selTempInd + 1}.png`, posDetail).then(src => {
            set_tempSrc(src);
        })
    }, [selTempInd])

    const handleCopy = () => {
        const textToCopy = 'www.oosa.com/event/invite/01';
        if (navigator.clipboard) {
            navigator.clipboard.writeText(textToCopy).then(() => {
                console.log('Text copied to clipboard');
            }).catch(err => {
                console.error('Failed to copy text: ', err);
            });
        } else {
            console.error('Clipboard API is not available.');
        }
    };

    return (
        <div className={style.modalBottom}>
            <CSSTransition in={inProp} timeout={{
                appear: 0,
                enter: 300,
                exit: 0,
            }} classNames={{
                enterActive: style.UpPageEnterActive,
                enterDone: style.UpPageEnterDone,
                exitActive: style.UpPageExit,
                exitDone: style.UpPageExitActive
            }}
            >
                <div className={`${style.UpPage}`} >
                    <CSSTransition in={inProp} timeout={{
                        appear: 0,
                        enter: 300,
                        exit: 0,
                    }} classNames={{
                        enterActive: style.UpPageEnterActive,
                        enterDone: style.UpPageEnterDone,
                        exitActive: style.UpPageExit,
                        exitDone: style.UpPageExitActive
                    }}
                        onExited={async () => {
                            await new Promise(resolve => requestAnimationFrame(resolve));
                            setModalType(prev => prev.filter(v => v.cls !== "SendInvite"))
                        }}
                    >
                        <div className={`${style.UpPage} ${style.page}`} id="background" onClick={event => {
                            if (event.target.id == "background") {
                                //modalThrough 的話點不到 ，也不合理
                            }
                        }}>
                            <div className={styleUi.app}>
                                <div className={styleUi.header}>
                                    <img src="./assets/ui/back.png" onClick={e => {
                                        if (state === 0) {
                                            arg.cb();
                                            setInProp(false);
                                        }
                                        else {
                                            set_state(prev => prev - 1);
                                        }
                                    }} />
                                </div>
                                {state === 0 &&
                                    <div className={styleUi.editing}>
                                        <YStyled.InviteBg className={styleUi.style1} img={tempSrc}>
                                        </YStyled.InviteBg>
                                        <div className={styleUi.tmpList}>
                                            <TabList selectId={selTempInd} set_selectId={set_selTempInd} list={[0, 1, 2, 3, 4, 5]} ItemCls={TempItem} clear={false} />
                                        </div>


                                        <YStyled.BTN3 style={{ position: "absolute", bottom: "0px", width: "100%", borderWidth: "0px", background: "#F2CE3E", color: "#000", padding: "1.5rem 0rem 2rem 0" }} onClick={e => {
                                            set_state(prev => prev + 1);
                                        }}>
                                            <YStyled.Span size={17} fontWeight={600}>下一步</YStyled.Span>
                                        </YStyled.BTN3>
                                    </div>
                                }
                                {state === 1 &&
                                    <div className={styleUi.editing}>
                                         <YStyled.InviteBg img={`./assets/ui/invite${selTempInd + 1}b.png`}>
                                            <YStyled.StyledTextarea value={msg}
                                                className={styleUi.input}
                                                marginTop={AppConfig.msgPos[selTempInd].marginTop}
                                                lineHeight={AppConfig.msgPos[selTempInd].lineHeight}
                                                height={AppConfig.msgPos[selTempInd].height}
                                                width={AppConfig.msgPos[selTempInd].width}
                                                onChange={e => {
                                                    let lines = e.target.value.split('\n');
                                                    if (lines.length <= AppConfig.msgPos[selTempInd].col && e.target.value.length <= 50)
                                                        set_msg(e.target.value);
                                                }}></YStyled.StyledTextarea>

                                        </YStyled.InviteBg>
                                        <YStyled.BTN3 style={{ position: "absolute", bottom: "0px", width: "100%", borderWidth: "0px", background: "#F2CE3E", color: "#000", padding: "1.5rem 0rem 2rem 0" }} onClick={e => {
                                            set_state(prev => prev + 1);
                                        }}>
                                            <YStyled.Span size={17} fontWeight={600}>下一步</YStyled.Span>
                                        </YStyled.BTN3>
                                    </div>
                                }
                                {state === 2 &&
                                    <div className={styleUi.complete}>
                                        <div className={styleUi.bg}>
                                            <SwifeItem enabled={true} page1={
                                                <YStyled.InviteBg img={tempSrc}>
                                                </YStyled.InviteBg>
                                            }
                                                page2={
                                                    <YStyled.InviteBg img={`./assets/ui/invite${selTempInd + 1}b.png`}>
                                                        <YStyled.StyledTextarea readOnly  style={{ userSelect: 'none', pointerEvents: 'none' }}  value={msg}
                                                            marginTop={AppConfig.msgPos[selTempInd].marginTop}
                                                            lineHeight={AppConfig.msgPos[selTempInd].lineHeight}
                                                            height={AppConfig.msgPos[selTempInd].height}
                                                            width={AppConfig.msgPos[selTempInd].width}
                                                        ></YStyled.StyledTextarea>
                                                    </YStyled.InviteBg>
                                                }
                                            ></SwifeItem>
                                        </div>
                                        <YStyled.BTN3 style={{ position: "absolute", bottom: "0px", width: "100%", borderWidth: "0px", background: "#F2CE3E", color: "#000", padding: "1.5rem 0rem 2rem 0" }} onClick={e => {
                                            console.log("friends", friends);
                                            const participantsId = participants.map(v => v.event_participants_user_detail.user_id);
                                            //
                                            console.log("participantsId", participantsId);
                                            const filterFriend = friends.reduce((acc, v) => {
                                                if (!participantsId.includes(v.user_friends_detail.user_id)) {
                                                    acc.push(v.user_friends_detail);
                                                }
                                                return acc;
                                            }, []);
                                            addModalType({
                                                cls: "InviteMember", arg: {
                                                    vo: arg.vo,
                                                    users: filterFriend,
                                                    template: (selTempInd + 1),
                                                    message: msg,
                                                    cb: () => {
                                                        arg.cb();
                                                        setInProp(false);
                                                    }
                                                }
                                            })
                                        }}>
                                            <YStyled.Span size={17} fontWeight={600}>邀請好友</YStyled.Span>
                                        </YStyled.BTN3>
                                    </div>
                                }
                            </div>
                        </div>
                    </CSSTransition>
                </div>
            </CSSTransition>
        </div>
    );
}

const TempItem = ({ isSelect, data, index, onClick }) => {
    useEffect(() => {
    }, [])
    return (
        <div onClick={e => { onClick(index) }} className={isSelect ? `${styleUi.item} ${styleUi.selected}` : styleUi.item}>
            <img src={`./assets/ui/invite${index + 1}.png`} />
            <div className={styleUi.arrow}></div>
        </div>
    );
}
export default memo(SendInvite);